// src/components/DataTable.js
import React, { useEffect, useState } from 'react';
import {
  Table as DataTable,
  Button,
  notification,
  Modal,
  Checkbox,
  message,
} from 'antd';
import axios from 'axios';
import '../css/antd.css';

import '../css/reportColoring.css';
import '../css/courselImage.css';

import 'bootstrap/dist/css/bootstrap.min.css';

import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { Modal as BsModal } from 'bootstrap';

import { CSVLink } from 'react-csv';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable'; // Import the autoTable plugin
import * as XLSX from 'xlsx';
import { Link } from 'react-router-dom';
import ModalForm from './ModalForm';
import DeleteModal from './DeleteModal';

import { APP_LOGO, CURRENT_DATE } from '../constants';
import UpdateModal from './UpdateModal';
import { decodeToken } from '../utils/TokenUtils';
import { API_URL, ENDPOINTS } from '../constants/api';
import FeatherIcon from 'feather-icons-react';
import { removeColumns, removeFields } from '../utils/ktcUtils';
import DetailData from './DetailData';
import FormQuery from './FormQuery';
import InsertQuery from './InsertQuery';
import SmsModal from './SmsModal';
import { useTranslation } from 'react-i18next';
import { updateColumn, updateColumn2 } from '../constants/functions';
import DataModal from './DataModal';

const DTTable = ({
  data,
  reportHeader,
  reportFooter,
  link,
  token,
  executionTime,
  editDelPermission,
}) => {
  const title = link?.page_title;
  // console.log("page title :",title);

  const [showModal, setShowModal] = useState(false);

  const isImage = (t) =>
    t.toLowerCase().endsWith('.jpg') ||
    t.toLowerCase().endsWith('.png') ||
    t.toLowerCase().endsWith('.jpeg') ||
    t.toLowerCase().endsWith('.gif') ||
    t.toLowerCase().endsWith('.webp') ||
    t.toLowerCase().endsWith('.jfif');

  const { t } = useTranslation();
  const [isSmsModalOpen, setIsSmsModalOpen] = useState(false);

  const openSmsModal = () => setIsSmsModalOpen(true);

  const closeSmsModal = () => setIsSmsModalOpen(false);
  //console.log('editDelPermission:', editDelPermission);
  const handelTeacherPeriod = async (req) => {
    // console.log('req: ', req);
    var insertUrl = `${API_URL}/${ENDPOINTS.SYS}/create/add-remove-teacher-period`;
    const response = await axios.post(insertUrl, req, {
      headers: {
        Authorization: token ? `Bearer ${token}` : '',
      },
    });
    notification.success({ message: response.data.message });
  };

  const isColor = (str) => {
    if (!str) return false;
    // simple regex for hex colors (#fff, #ffffff)
    const hexColorRegex = /^#([0-9A-Fa-f]{3}){1,2}$/;
    // regex for rgb(a) colors
    const rgbColorRegex =
      /^rgba?\(\s*\d+\s*,\s*\d+\s*,\s*\d+(\s*,\s*(0|1|0?\.\d+))?\s*\)$/i;
    // list of basic CSS color names (you can expand)
    const cssColorNames = [
      'red',
      'blue',
      'green',
      'white',
      'black',
      'yellow',
      'orange',
      'purple',
      'pink',
      'brown',
      'gray',
      'grey',
    ];

    return (
      hexColorRegex.test(str) ||
      rgbColorRegex.test(str) ||
      cssColorNames.includes(str.toLowerCase())
    );
  };

  const userId = decodeToken(token, 'id');
  const companyBanner = decodeToken(token, 'banner');
  const pageSize = decodeToken(token, 'banner')
    ? 10
    : decodeToken(token, 'banner');
  // console.log('link2:', link);

  const [columns, setColumns] = useState([]);
  const [search, setSearch] = useState('');
  const [currentRoute, setCurrentRoute] = useState('');
  const [queryParams, setQueryParms] = useState('');

  const [loading, setLoading] = useState(false);

  const [deleteId, setDeleteId] = useState(null);
  const [updateId, setUpdateId] = useState(null);
  const [updateId2, setUpdateId2] = useState(null);

  const [printedId, setPrintedId] = useState(null);

  const [updateTable, setUpdateTable] = useState(null);

  const [selectedColumns, setSelectedColumns] = useState([]);
  const [columns2, setColumns2] = useState([]);

  const [detailModalVisible, setDetailModalVisible] = useState(false);
  const [modalContent, setModalContent] = useState('');

  // Handle opening the modal
  const openDetailModal = (content) => {
    //console.log('clicked deail');
    setModalContent(content);
    setDetailModalVisible(true);
  };

  const closeDetailModal = () => {
    setDetailModalVisible(false);
  };

  function openGallery(images, startIndex = 0) {
    const container = document.getElementById('carousel-inner-container');
    container.innerHTML = '';

    images.forEach((img, i) => {
      const active = i === startIndex ? 'active' : '';
      const encoded = encodeURI(img);

      container.innerHTML += `
      <div class="carousel-item ${active} h-100">
        <img src="${API_URL}/${encoded}" class="gallery-img" />
      </div>
    `;
    });

    const modalElement = document.getElementById('galleryModal');
    const modal = BsModal.getOrCreateInstance(modalElement);
    modal.show();
  }

  const [statementModalVisible, setStatementModalVisible] = useState(false);
  const [statement, setSatetment] = useState([]);

  // Handle opening the modal
  const openStatementlModal = (id) => {
    //console.log('clicked deail');
    //setModalContent(content);
    fetchStatement(id);
    setStatementModalVisible(true);
  };

  const fetchStatement = async (id) => {
    const top_navbar_statement_link_id = decodeToken(
      token,
      'top_navbar_statement_link_id'
    );
    const endpoint = `${API_URL}/${ENDPOINTS.SYS}/get-top-navbar-statement/${top_navbar_statement_link_id}`;
    //console.log(url);

    const res = await axios.get(endpoint, {
      headers: {
        Authorization: token ? `Bearer ${token}` : '',
      },
    });
    // console.log(response.data); // to handle customer-statement patient-statement student-statement
    const statement_route = res.data.link[0]?.route || 'customer-statement';
    // console.log('in statement route: link', link, 'route: ', statement_route);
    let statementUrl;

    if (API_URL.includes('imaamshafici') || API_URL.includes('aqoonkaal')) {
      statementUrl = `${API_URL}/${ENDPOINTS.SYS}/reportCustom/student-statement`;
    } else {
      statementUrl = `${API_URL}/${ENDPOINTS.SYS}/reportCustom/${statement_route}`;
    }
    const values = {
      _id: id,
      from: '0000-00-00',
      to: CURRENT_DATE,
      user_id: userId,
    };
    const response = await axios.post(statementUrl, values, {
      headers: {
        Authorization: token ? `Bearer ${token}` : '',
      },
    });
    // console.log(response.data);
    setSatetment(response.data.data);
  };

  const closeStatementModal = () => {
    setStatementModalVisible(false);
  };

  const fieldsToRemove = ['Action', 'Image', 'Print'];

  var insertUrl = `${API_URL}/${ENDPOINTS.SYS}/create/add-print-log`;

  const [modalVisible, setModalVisible] = useState(false); // Manage modal visibility

  const [updateRouteId, setUpdateRouteId] = useState(null);
  const userLevel = decodeToken(token, 'userLevel');
  //console.log('userLevel: ', userLevel, 'Token:', token);

  const [isModalUpdateOpen2, setIsModalUpdateOpen2] = useState(false);

  const openUpdateModal2 = (id, table, routeId) => {
    if (userLevel === 'developer') {
      setUpdateId2(id);
      setUpdateTable(table);
      setUpdateRouteId(routeId);

      // setUpdateTable()
      setIsModalUpdateOpen2(true);
    }
  };
  const closeUpdateModal2 = () => {
    setUpdateId2(null);
    setIsModalUpdateOpen2(false);
  };

  // Function to handle delete button click
  const handleDelete = (id) => {
    setDeleteId(id);
    setModalVisible(true); // Open the modal on delete click
  };

  const handleCancel = () => {
    setModalVisible(false); // Close the modal without deleting
  };

  const [isModalUpdateOpen, setIsModalUpdateOpen] = useState(false);

  const openUpdateModal = (id) => {
    setUpdateId(id);
    // setUpdateTable()
    setIsModalUpdateOpen(true);
  };
  const closeUpdateModal = () => {
    setUpdateId(null);
    setIsModalUpdateOpen(false);
  };

  const [isModalFormOpen, setIsModalFormOpen] = useState(false);

  const openFormModal = (route, queryParams) => {
    // console.log('queryParams:', queryParams);
    setCurrentRoute(route);
    setQueryParms(queryParams);
    // setUpdateTable()
    setIsModalFormOpen(true);
  };
  const closeFormModal = () => {
    setUpdateId(null);
    setIsModalFormOpen(false);
  };
  const [formQueryId, setFormQueryId] = useState(null);
  const [queryType, setQueryType] = useState(null);

  const [isModalPrintOpen, setIsModalPrintOpen] = useState(false);

  const openPrintModal = (id) => {
    setPrintedId(id);
    // setUpdateTable()
    setIsModalPrintOpen(true);
  };
  const closePrintModal = () => {
    setUpdateId(null);
    setIsModalPrintOpen(false);
  };

  const [isModalFormQueryOpen, setIsModalFormQueryOpen] = useState(false);

  const openFormQueryModal = (id, type = 'form') => {
    setFormQueryId(id);
    setQueryType(type);

    // setUpdateTable()
    setIsModalFormQueryOpen(true);
  };
  const closeFormQueryModal = () => {
    setUpdateId(null);
    setIsModalFormQueryOpen(false);
  };

  const [isModalInsertQueryOpen, setIsModalInsertQueryOpen] = useState(false);
  const [insertQueryId, setInsertQueryId] = useState(null);
  const [insertQueryTable, setInsertQueryTable] = useState(null);

  const openInsertQueryModal = (id, table) => {
    setInsertQueryId(id);
    setInsertQueryTable(table);
    // console.log(id, table);

    // setUpdateTable()
    setIsModalInsertQueryOpen(true);
  };

  const closeInsertQueryModal = () => {
    setUpdateId(null);
    setIsModalInsertQueryOpen(false);
  };

  const isNumeric = (val) => {
    if (val === null || val === undefined) return false;

    if (typeof val === 'number') return true;

    if (typeof val === 'string') {
      const cleaned = val
        .replace(/[^0-9.-]/g, '') // 🔥 remove currency symbols & text
        .trim();

      return cleaned !== '' && !isNaN(cleaned);
    }

    return false;
  };

  const toNumber = (val) => {
    if (val === null || val === undefined) return 0;

    if (typeof val === 'number') return val;

    return Number(
      String(val)
        .replace(/[^0-9.-]/g, '') // 🔥 keep digits, minus, dot only
        .trim()
    );
  };

  const generateColumns = (data) => {
    if (data && data.length === 0) return []; // If data is empty, return empty columns

    // Get the keys from the first row of data (assuming it's an object)
    const keys = Object.keys(data[0]);

    // Map through the keys to generate column definitions
    // Exclude 'color' column from being displayed

    const baseColumns = keys
      .filter(
        (key) =>
          key !== 'color' &&
          key !== 'can_edit_delete' &&
          !key.startsWith('delete') &&
          !key.includes('hide')
      )
      .map((key) => {
        const parts = key.split('~'); // Split the key by '~'
        const columnTitle = parts[0]; // The first part is the column title
        const hasShowDetail = parts.includes('showDetail'); // Check if 'showDetail' exists
        // console.log('parts : ',parts)
        // const color =
        //   parts.includes('red') ||
        //   parts.includes('blue') ||
        //   parts.includes('green')
        //     ? parts.find((part) => ['red', 'blue', 'green'].includes(part))
        //     : null; // Check if there's a color

        const color = parts.find(isColor) || null;

        return {
          title: t(columnTitle.charAt(0).toUpperCase() + columnTitle.slice(1)), // Capitalize column title
          dataIndex: key,
          key: key,
          sorter: (a, b) => {
            const av = a[key];
            const bv = b[key];

            const aIsNum = isNumeric(av);
            const bIsNum = isNumeric(bv);

            if (aIsNum && bIsNum) {
              return toNumber(av) - toNumber(bv); // 🔥 numeric sort
            }

            // fallback to string sort
            return String(av ?? '').localeCompare(String(bv ?? ''));
          },

          sortDirections: ['ascend', 'descend'],
          render: (text) => {
            if (typeof text === 'string') {
              if (text.includes('type=') && text.includes('period_id=')) {
                const periodMatch = text.match(/period_id="(\d+)"/);
                const period_id = periodMatch ? periodMatch[1] : null;
                const teacherMatch = text.match(/teacher_id="(\d+)"/);
                const teacher_id = teacherMatch ? teacherMatch[1] : null;
                const branchMatch = text.match(/branch_id="(\d+)"/);
                const branch_id = branchMatch ? branchMatch[1] : null;
                // Extract type
                const typeMatch = text.match(/type="(\w+)"/);
                const type = typeMatch ? typeMatch[1] : null;
                // console.log(period_id);
                // console.log(type);
                if (period_id && type) {
                  const req = {
                    branch_id: branch_id,
                    teacher_id: teacher_id,
                    period_id: period_id,
                    user_id: userId,
                    type: type,
                  };
                  return (
                    <button
                      key={period_id}
                      onClick={() => handelTeacherPeriod(req)}
                      style={{
                        background: 'transparent',
                        border: 'none',
                        cursor: 'pointer',
                        padding: 0,
                        display: 'inline-flex',
                        alignItems: 'center',
                      }}
                    >
                      <FeatherIcon
                        icon={type === 'check' ? 'check' : 'x'}
                        size={28}
                        color={type === 'check' ? 'green' : 'red'}
                      />
                    </button>
                  );
                }
              }
              // Regex to extract href, class, and inner text
              const anchorRegex =
                /^<a[^>]+href="([^"]+)"[^>]*className="([^"]+)"[^>]*>([^<]+)<\/a>$/;
              const match = text.match(anchorRegex);

              const regex0 =
                /<a\s+href="([^"]+)"\s+className="([^"]+)"\s+title="([^"]+)">([^<]+)<\/a>/;
              const match0 = text.match(regex0);
              //check only if it anchor
              const anchorRegex2 = /<a[^>]+href="([^"]+)"[^>]*>([^<]+)<\/a>/;
              const match2 = text.match(anchorRegex2);

              if (match || match0) {
                let href = ''; // Extract href from <a>
                let className = ''; // Extract className from <a>
                let displayText = ''; // Extract inner text of <a>
                let title = ''; // Extract title text of <a>

                if (match) {
                  href = match[1]; // Extract href from <a>
                  className = match[2]; // Extract className from <a>
                  displayText = match[3]; // Extract inner text of <a>
                }

                if (match0) {
                  href = match0[1]; // Extract href from <a>
                  className = match0[2]; // Extract className from <a>
                  displayText = match0[4]; // Extract inner text of <a>
                  title = match0[3]; // Extract title text of <a>
                }

                // console.log(
                //   'match:',
                //   match,
                //   'href:',
                //   href,
                //   'className:',
                //   className,
                //   'displayText:',
                //   displayText,
                //   'title:',
                //   title
                // );

                if (href.startsWith('updatecolumn/')) {
                  return (
                    <button
                      className={`btn ${className}`}
                      onClick={(e) => updateColumn(e, href, title)}
                      key={key}
                    >
                      {displayText}
                    </button>
                  );
                }

                if (href.startsWith('updatecolumn2/')) {
                  return (
                    <button
                      className={`btn ${className}`}
                      onClick={(e) => updateColumn2(e, href, title)}
                      key={key}
                    >
                      {displayText}
                    </button>
                  );
                }
                if (href.startsWith('push--')) {
                  return (
                    <button
                      className={`btn ${className}`}
                      onClick={(e) => pushApi(e, href.replace('push--', ''))}
                      key={key}
                    >
                      {displayText}
                    </button>
                  );
                }
                if (href.startsWith('printedDataId/')) {
                  const printedDataId = href.split('/')[1];
                  return (
                    <button
                      className={`btn ${className}`}
                      onClick={(e) => openPrintModal(printedDataId)}
                      key={key}
                    >
                      {displayText}
                    </button>
                  );
                }
                if (href.startsWith('copyFormQuery/')) {
                  const formId = href.split('/')[1];
                  return (
                    <button
                      className={`btn ${className}`}
                      onClick={(e) => openFormQueryModal(formId, 'form')}
                      key={key}
                    >
                      {displayText}
                    </button>
                  );
                }
                if (href.startsWith('copyCategoryQuery/')) {
                  const categoryId = href.split('/')[1];
                  return (
                    <button
                      className={`btn ${className}`}
                      onClick={(e) =>
                        openFormQueryModal(categoryId, 'category')
                      }
                      key={key}
                    >
                      {displayText}
                    </button>
                  );
                }
                if (href.startsWith('insertQuery/')) {
                  const formId = href.split('/')[1];
                  const table = href.split('/')[2];

                  return (
                    <button
                      className={`btn ${className}`}
                      onClick={(e) => openInsertQueryModal(formId, table)}
                      key={key}
                    >
                      {displayText}
                    </button>
                  );
                }
                if (href.startsWith('form-modal?')) {
                  const route = href.split('?')[1];
                  const queryParms = href.split('?')[2];

                  return (
                    <button
                      className={`btn ${className}`}
                      onClick={(e) => openFormModal(route, queryParms)}
                      key={key}
                    >
                      {displayText}
                    </button>
                  );
                } else
                  return (
                    <a
                      href={href}
                      className={`btn ${className}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      key={key}
                    >
                      {displayText}
                    </a>
                  );
              }

              if (match2) {
                const href = match2[1]; // Extracted href value
                const linkText = match2[2]; // Extracted link text

                const shouldOpenInNewTab =
                  href.startsWith('/invoice') ||
                  href.startsWith('/pos-invoice') ||
                  href.startsWith('/qrcode') ||
                  href.startsWith('/sales-invoice') ||
                  href.includes('wa.me'); // ✅ ADD THIS

                if (shouldOpenInNewTab) {
                  // Use a plain <a> for new tab
                  return (
                    <a href={href} target="_blank" rel="noopener noreferrer">
                      {linkText}
                    </a>
                  );
                } else {
                  console.log('.');

                  // Normal React Router Link
                  return <Link to={href}>{linkText}</Link>;
                }
              }

              // MULTI
              if (isImage(text) && text.includes(',')) {
                const arr = text.split(',').map((t) => t.trim());

                return (
                  <div className="d-flex gap-2">
                    {arr.map((img, i) => {
                      const encoded = encodeURI(img);
                      return (
                        <img
                          key={i}
                          src={`${API_URL}/${encoded}`}
                          style={{
                            width: 50,
                            height: 50,
                            objectFit: 'cover',
                            cursor: 'pointer',
                          }}
                          onClick={() => openGallery(arr, i)}
                        />
                      );
                    })}
                    <button
                      className="btn btn-sm btn-secondary"
                      onClick={() => openGallery(arr, 0)}
                    >
                      View All
                    </button>
                  </div>
                );
              }

              // SINGLE
              if (isImage(text)) {
                const encodedPath = encodeURI(text);
                // console.log('encodepath',encodedPath);
                return (
                  <img
                    src={
                      text.includes('http') ? text : `${API_URL}/${encodedPath}`
                    }
                    alt="Image Not Found"
                    key={key}
                    style={{
                      width: 50,
                      height: 50,
                      objectFit: 'cover',
                      cursor: 'pointer',
                    }}
                    onClick={() => openGallery([text], 0)}
                  />
                );
              }

              if (
                text.endsWith('.pdf') ||
                text.endsWith('.doc') ||
                text.endsWith('.docx') ||
                text.endsWith('.xlsx') ||
                text.endsWith('.xls') ||
                text.endsWith('.ppt') ||
                text.endsWith('.pptx') ||
                text.endsWith('.csv') ||
                text.endsWith('.txt') ||
                text.endsWith('.mp4') ||
                text.endsWith('.mov') ||
                text.endsWith('.wmv') ||
                text.endsWith('.avi')
              ) {
                return (
                  <a
                    href={`${API_URL}/${text}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: '#007bff', textDecoration: 'underline' }}
                    key={key}
                  >
                    Preview or Download
                  </a>
                );
              }

              if (
                typeof text === 'string' &&
                text.includes('<') &&
                text.includes('>')
              ) {
                console.log('this');
                return <div dangerouslySetInnerHTML={{ __html: text }} />;
              }
            }
            return text;
          },
          // Apply conditional row styling if a color is found
          className: color ? `row-color-${color}` : '', // Apply color class if available
        };
      });

    return [...baseColumns];
    // return [...baseColumns];
  };

  // Handle checkbox toggle
  const handleCheckboxChange = (columnName) => {
    setSelectedColumns((prevSelected) => {
      if (prevSelected.includes(columnName)) {
        // If already selected, remove it
        return prevSelected.filter((col) => col !== columnName);
      } else {
        // If not selected, add it
        return [...prevSelected, columnName];
      }
    });
  };

  useEffect(() => {
    // Dynamically create columns based on data keys
    try {
      const cols = generateColumns(data);
      // console.log('cols:', cols);
      const editDelColumns = {
        title: 'Action',
        key: 'Action',
        render: (_, record) => (
          <>
            {record.ID && (record.ID !== '' || record.ID !== 0) && (
              <>
                {editDelPermission.can_edit === 1 && (
                  <Button
                    type="danger"
                    onClick={() => openUpdateModal(record.ID)}
                    key={`btn-edit-${record.ID}`}
                  >
                    <FeatherIcon
                      icon="edit"
                      size={20}
                      style={{ cursor: 'pointer', color: '#007bff' }}
                      key={`icon-edit-${record.ID}`}
                    />
                  </Button>
                )}
                {editDelPermission.can_delete === 1 && (
                  <Button
                    type="danger"
                    onClick={() => handleDelete(record.ID)}
                    loading={loading && deleteId === record.ID}
                    key={`btn-del-${record.ID}`}
                  >
                    <FeatherIcon
                      icon="trash-2"
                      size={20}
                      style={{ cursor: 'pointer', color: '#dc3545' }}
                      key={`icon-del-${record.ID}`}
                    />
                  </Button>
                )}
              </>
            )}
          </>
        ),
      };

      const cols2 = cols.some((col) => col.key === 'ID')
        ? [...cols, editDelColumns]
        : cols;

      // console.log('cols2:', cols2);
      setColumns(cols2);
      setSelectedColumns(cols2); // By default, all columns are selected

      //Extract column names (keys) from the first item of data
      if (data && data.length > 0) {
        const cols = Object.keys(data[0]); // Get all columns from the first data object
        const cols2 = cols.some((col) => col === 'ID')
          ? [...cols, 'Action']
          : cols;

        setColumns2(cols2); // Set column names
        // console.log('cols22:', cols2);
        setSelectedColumns(cols2); // By default, all columns are selected
      }
    } catch (error) {
      notification.error({ message: error.message });
    }
  }, [data]);

  const handleSearch = (e) => {
    setSearch(e.target.value);
  };
  //// this was used old fileter data
  // var filteredData;
  // try {

  //   filteredData = data.filter((row) =>
  //     Object.values(row).some((val) =>
  //       String(val).toLowerCase().includes(search.toLowerCase())
  //     )
  //   );

  // } catch (error) {
  //   notification.error({ message: error.message });
  // }

  var filteredData;
  try {
    const shouldUseSummary = link.has_footer === '1';

    let summaryRow = null;
    let dataToFilter = data;

    // Handle footer only if it's valid
    if (shouldUseSummary && Array.isArray(data) && data.length > 0) {
      summaryRow = data[data.length - 1];

      // Ensure summaryRow is an object
      if (typeof summaryRow === 'object' && !Array.isArray(summaryRow)) {
        dataToFilter = data.slice(0, data.length - 1);
      } else {
        summaryRow = null;
      }
    }

    // Apply filtering
    const filtered = dataToFilter.filter((row) =>
      Object.values(row).some((val) =>
        String(val).toLowerCase().includes(search.toLowerCase())
      )
    );
    // console.log(
    //   'summaryRow:',
    //   summaryRow,
    //   'dataToFilter:',
    //   dataToFilter,
    //   'filtered:',
    //   filtered
    // );
    // Final result
    filteredData = summaryRow ? [...filtered, summaryRow] : filtered;
  } catch (error) {
    notification.error({ message: error.message });
  }

  const getBase64FromUrl = async (imageUrl) => {
    const response = await fetch(imageUrl);
    const blob = await response.blob();

    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(blob);
    });
  };

  const exportToPDF = async () => {
    try {
      // console.log('log response: ', response.data, 'daa:', printLogs)
      const doc = new jsPDF();
      const banner = `${API_URL}/${companyBanner}`;
      // console.log('banner:', banner);
      // Convert image URL to Base64

      const imageBase64 = await getBase64FromUrl(banner);

      // Add the banner image
      const pageWidth = doc.internal.pageSize.getWidth();
      const imgHeight = 40; // Fixed height for the banner image
      const imgY = 10; // Start 10 units from the top

      doc.addImage(imageBase64, 'PNG', 0, imgY, pageWidth, imgHeight);

      // Add title below the banner image
      const titleY = imgY + imgHeight + 10;
      doc.setFontSize(16);
      const textWidth = doc.getTextWidth(title);
      const titleX = (pageWidth - textWidth) / 2;
      doc.text(title, titleX, titleY);

      // Add JSON key-value header data in a grid layout
      doc.setFontSize(12);
      let yOffset = titleY + 10; // Start position for the header
      if (reportHeader && reportHeader.length > 0) {
        const headerKeys = Object.entries(reportHeader[0]);

        for (let i = 0; i < headerKeys.length; i += 2) {
          const firstPair = headerKeys[i];
          const secondPair = headerKeys[i + 1];

          doc.text(`${firstPair[0]}: ${firstPair[1]}`, 14, yOffset);

          if (secondPair) {
            doc.text(`${secondPair[0]}: ${secondPair[1]}`, 110, yOffset);
          }

          yOffset += 7;
        }
      }

      // Compute unselected columns
      const unCheckedFields = columns2.filter(
        (col) => !selectedColumns.includes(col)
      );

      // Combine default fields with unchecked columns
      const combinedFieldsToRemove = [...fieldsToRemove, ...unCheckedFields];

      const printFilteredData = removeColumns(
        filteredData,
        combinedFieldsToRemove
      );

      const keys = Object.keys(printFilteredData[0]);

      const tableColumn = keys.map((col) => col);

      // console.log('Data: ', filteredData)
      const tableRows = filteredData.map((row) => {
        const record0 = columns.map((col) => row[col.key]);
        // const record = columns.map(col => escapeSingleQuotes(String(row[col.key])));

        //console.log('row:', row, 'record:', record0, 'record0:', record0); // Log the row to check if the data is correct
        return record0;
      });

      // Generate PDF with autoTable plugin
      doc.autoTable({
        startY: yOffset + 10, // Start table below the header

        head: [tableColumn],
        body: tableRows,
      });

      doc.save(title + '.pdf');

      const printLogs = {
        user_id: userId,
        link_id: link.id,
        print_data: JSON.stringify(printFilteredData),
        header_data: '',
        footer_data: '',
        ip_address: '',
        user_agent: '',
        print_action: 'pdf',
      };
      try {
        const response = await axios.post(insertUrl, printLogs, {
          headers: {
            Authorization: token ? `Bearer ${token}` : '',
          },
        });
      } catch (err) {
        notification.error({ message: err.message });
      }
    } catch (err) {
      console.log('err:', err.message);
      notification.error({
        message: 'Please update Letter head in company profile',
      });
    }
  };

  const exportToExcel = async () => {
    // Compute unselected columns
    const unCheckedFields = columns2.filter(
      (col) => !selectedColumns.includes(col)
    );

    // Combine default fields with unchecked columns
    const combinedFieldsToRemove = [...fieldsToRemove, ...unCheckedFields];

    const printFilteredData = removeColumns(
      filteredData,
      combinedFieldsToRemove
    );

    const printLogs = {
      user_id: userId,
      link_id: link.id,
      print_data: JSON.stringify(printFilteredData),
      header_data: '',
      footer_data: '',
      ip_address: '',
      user_agent: '',
      print_action: 'excel',
    };
    try {
      const response = await axios.post(insertUrl, printLogs, {
        headers: {
          Authorization: token ? `Bearer ${token}` : '',
        },
      });
    } catch (err) {
      console.log('err', err.message);
      notification.error({ message: err.message });
    }
    const ws = XLSX.utils.json_to_sheet(printFilteredData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'data');
    XLSX.writeFile(wb, title + '.xlsx');
  };

  const exportToCsv = async (e) => {
    const printLogs = {
      user_id: userId,
      link_id: link.id,
      print_data: JSON.stringify(filteredData),
      header_data: '',
      footer_data: '',
      ip_address: '',
      user_agent: '',
      print_action: 'csv',
    };
    try {
      const response = await axios.post(insertUrl, printLogs, {
        headers: {
          Authorization: token ? `Bearer ${token}` : '',
        },
      });
    } catch (err) {
      notification.error({ message: err.message });
    }
  };

  const CopyToClipboard = () => {
    // Remove unwanted columns
    const data = removeColumns(filteredData, fieldsToRemove);

    // Build header row
    const headers = selectedColumns.join('\t');

    // Build data rows
    const rows = data.map((row) =>
      selectedColumns
        .map((col) => {
          let val = row[col];

          if (val == null) return '';

          val = val.toString();

          if (
            /^\d{2}\/\d{2}\/\d{4}$/.test(val) ||
            /^\d{4}-\d{2}-\d{2}$/.test(val)
          ) {
            return `="${val}"`;
          }

          // Prevent scientific notation for numbers
          if (/^\d{8,}$/.test(val)) {
            return `="${val}"`;
          }

          // Escape tabs/newlines
          if (/[\t\n]/.test(val)) {
            return `"${val}"`;
          }

          return val;
        })
        .join('\t')
    );

    const text = [headers, ...rows].join('\n');

    navigator.clipboard.writeText(text).then(() => {
      notification.success({
        message: 'Table data copied! Paste it into Excel.',
      });
    });
  };

  const pushApi = async (e, href) => {
    e.preventDefault();
    const updateUrl = `${API_URL}/${ENDPOINTS.SYS}/${href}`;
    // console.log(updateUrl);
    try {
      const response = await axios.get(
        updateUrl,

        {
          headers: {
            Authorization: token ? `Bearer ${token}` : '',
          },
        }
      );

      //console.log(`response: `,response.data)

      notification.success({ message: response.data.message });
    } catch (error) {
      //console.log(`url: ${updateUrl}, error ${error.message}`)
      notification.error({ message: error.message });
    }
  };

  const openInNewTab = async (e) => {
    e.preventDefault(); // Prevent default behavior of the Link

    // const noPrint = ['Action', 'Image', 'Print'];
    // const printFilteredData = removeFields(filteredData, noPrint)

    // Compute unselected columns
    const unCheckedFields = columns2.filter(
      (col) => !selectedColumns.includes(col)
    );

    // Combine default fields with unchecked columns
    const combinedFieldsToRemove = [...fieldsToRemove, ...unCheckedFields];

    const printFilteredData = removeColumns(
      filteredData,
      combinedFieldsToRemove
    );

    const jsonData = {
      title: title,
      logo: APP_LOGO,
      tableData: printFilteredData,
      reportHeader: reportHeader,
      reportFooter: reportFooter,
    };

    const printLogs = {
      user_id: userId,
      link_id: link.id,
      print_data: JSON.stringify(printFilteredData),
      header_data: '',
      footer_data: '',
      ip_address: '',
      user_agent: '',
      print_action: 'print',
    };
    const response = await axios.post(insertUrl, printLogs, {
      headers: {
        Authorization: token ? `Bearer ${token}` : '',
      },
    });

    localStorage.setItem('printData', JSON.stringify(jsonData)); // Store data in localStorage
    window.open('/print', '_blank'); // Open the link in a new tab
  };

  // console.log('link:', link);

  // Function to get row class name based on row's color column value
  const getRowClassName = (record) => {
    if (record.color) {
      return `row-color-${record.color.toLowerCase()}`; // Convert to lowercase to match class
    }
    return 'row-color-default'; // Default class if no color
  };

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);

  const handleRowCheckboxChange = (index, record, checked) => {
    // console.log('checked:', checked);
    let updatedKeys = [...selectedRowKeys];
    if (checked) {
      updatedKeys.push(index);
    } else {
      updatedKeys = updatedKeys.filter((k) => k !== index);
    }
    setSelectedRowKeys(updatedKeys);

    const selectedRows = filteredData.filter((_, i) => updatedKeys.includes(i));
    setSelectedRows(selectedRows);
    // console.log('Selected rows:', selectedRows);
  };

  const handleSelectAllChange = (checked) => {
    if (checked) {
      // Select all visible row indexes
      const allKeys = filteredData.map((_, index) => index);
      const selectedRows = filteredData.filter((_, i) => allKeys.includes(i));
      setSelectedRows(selectedRows);
      setSelectedRowKeys(allKeys);
    } else {
      setSelectedRowKeys([]);
    }
  };

  // ✅ Add the Action column
  const checkboxColumn = {
    title: (
      <Checkbox
        checked={selectedRowKeys.length === filteredData.length}
        indeterminate={
          selectedRowKeys.length > 0 &&
          selectedRowKeys.length < filteredData.length
        }
        onChange={(e) => handleSelectAllChange(e.target.checked)}
      />
    ),
    key: 'Check',
    dataIndex: 'check',

    render: (_, record, index) => (
      <Checkbox
        checked={selectedRowKeys.includes(index)}
        onChange={(e) =>
          handleRowCheckboxChange(index, record, e.target.checked)
        }
      />
    ),
  };

  // Final columns = checkbox + filtered columns
  const filteredColumns = [
    ...(link.sms_sample ? [checkboxColumn] : []),
    ...columns.filter((col) => selectedColumns.includes(col.key)),
  ];

  return (
    <div className="" style={{ padding: '20px' }}>
      <br />
      {isSmsModalOpen && (
        <SmsModal
          userId={userId}
          token={token}
          title={link?.page_title}
          defaultSms={link?.sms_sample}
          data={selectedRows}
          isOpen={isSmsModalOpen}
          onRequestClose={closeSmsModal}
        />
      )}
      <div className="row">
        {/* {link?.reg_route && 
        <div className='col-6'>
            <button className="btn btn-primary" onClick={openModal}>
            {link?.reg_name}
          </button>
         
          <ModalForm userId={userId}  token={token} route={link?.reg_route} isOpen={isModalOpen} onRequestClose={closeModal} />
         
        </div>
         } */}
        <div className="col-3">
          <h2
            onDoubleClick={() => openUpdateModal2(link?.id, 'ktc_link', 7)}
            title={
              userLevel === 'developer'
                ? `Double click to update/edit the ${link?.page_title} form`
                : '' + userLevel
            }
          >
            {title}
          </h2>
        </div>
      </div>

      {deleteId && (
        <DeleteModal
          userId={userId}
          token={token}
          table={link?.table_name}
          id={deleteId}
          modalVisible={modalVisible}
          setModalVisible={setModalVisible}
        />
      )}
      {updateId2 && (
        <UpdateModal
          userId={userId}
          token={token}
          table={updateTable}
          update_link_id={updateRouteId}
          id={updateId2}
          isOpen={isModalUpdateOpen2}
          onRequestClose={closeUpdateModal2}
        />
      )}
      {updateId && (
        <UpdateModal
          userId={userId}
          token={token}
          table={link?.table_name}
          update_link_id={link?.update_link_id}
          id={updateId}
          isOpen={isModalUpdateOpen}
          onRequestClose={closeUpdateModal}
        />
      )}
      {printedId && (
        <DetailData
          userId={userId}
          token={token}
          route="get-printed-data"
          title={title}
          id={printedId}
          isOpen={isModalPrintOpen}
          onRequestClose={closePrintModal}
        />
      )}

      {formQueryId && (
        <FormQuery
          userId={userId}
          token={token}
          route=""
          title={title}
          id={formQueryId}
          isOpen={isModalFormQueryOpen}
          type={queryType}
          onRequestClose={closeFormQueryModal}
        />
      )}

      {insertQueryId && (
        <InsertQuery
          userId={userId}
          token={token}
          route=""
          title={title}
          id={insertQueryId}
          table={insertQueryTable}
          isOpen={isModalInsertQueryOpen}
          onRequestClose={closeInsertQueryModal}
        />
      )}

      {isModalFormOpen && currentRoute && (
        <ModalForm
          userId={userId}
          token={token}
          queryParams={queryParams}
          route={currentRoute} // Pass the dynamic route to the modal
          isOpen={isModalFormOpen}
          onRequestClose={closeFormModal}
        />
      )}

      {/* Flexbox container for the buttons and search */}

      <div className="d-flex justify-content-between align-items-center mb-3">
        {/* Export Buttons - Left aligned */}
        {/* filteredData && filteredData.length > 0 && */}
        <div>
          <button onClick={exportToPDF} className="btn btn-primary mr-2">
            Export PDF
          </button>
          <a onClick={exportToCsv} className="" href="/">
            <CSVLink
              data={filteredData}
              filename={title + '.csv'}
              className="btn btn-success mr-2"
            >
              Export CSV
            </CSVLink>
          </a>
          <button onClick={exportToExcel} className="btn btn-warning mr-2">
            Export Excel
          </button>

          <Link
            to="/print"
            className="btn btn-info"
            onClick={openInNewTab} // Add the click handler
          >
            Print
          </Link>
          <button onClick={CopyToClipboard} className="btn btn-secondary mr-2">
            Copy
          </button>
          {link.sms_sample && (
            <button
              className="btn btn-danger"
              onClick={() => openSmsModal()} // Pass the specific route to the modal
            >
              Send Sms
            </button>
          )}
        </div>
        {/* User Profile Dropdown */}
        <ul className="navbar-nav ms-auto">
          <li className="nav-item dropdown">
            <a
              className="  dropdown-toggle"
              href="/"
              id="userDropdown"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              style={{ textDecoration: 'none' }}
            >
              Show/Hide
            </a>
            <ul
              className="dropdown-menu "
              style={{ zIndex: 1065 }}
              aria-labelledby="userDropdown"
            >
              {columns2.map((column) => (
                <li key={column} className="dropdown-item">
                  &nbsp;
                  <label>
                    <input
                      type="checkbox"
                      checked={selectedColumns.includes(column)} // Check if this column is selected
                      onChange={() => handleCheckboxChange(column)} // Toggle checkbox
                      key={`input-${column}`}
                    />
                    &nbsp;{column}
                  </label>
                </li>
              ))}
            </ul>
          </li>
        </ul>

        {/* Search Input - Right aligned */}
        <input
          type="text"
          placeholder="Search..."
          value={search}
          onChange={handleSearch}
          className="form-control mb-3"
          style={{ maxWidth: '300px' }} // Optional: Limit max width for better alignment
        />
      </div>
      <div className="container mt-4">
        {reportHeader && reportHeader.length > 0 && (
          <center>
            <h2>{title}</h2>
          </center>
        )}
        {reportHeader &&
          reportHeader.map((item, index) => (
            <div key={index} className="row mb-3">
              {Object.entries(item).map(([key, value], i) => (
                <div className="col-md-6 mb-2" key={i}>
                  <strong>{key}:</strong> {value}
                </div>
              ))}
            </div>
          ))}
      </div>

      {/* DataTable */}
      {data && data.length > 0 && (
        <div style={{ overflow: 'visible' }}>
          <DataTable
            //columns={columns}
            // columns={columns.filter((col) => selectedColumns.includes(col.key))}
            columns={filteredColumns}
            dataSource={
              link?.has_footer === '0'
                ? filteredData
                : filteredData.slice(0, -1)
            }
            // rowKey="name"
            rowKey={(_, index) => index} // <- ensures each row has a unique key based on index
            //scroll={{ x: 'max-content' }} // Adjusts table layout to prevent horizontal scrolling
            // rowClassName={(record) =>
            //   record.color ? `row-color-${record.color}` : ''
            // }

            // rowClassName={getRowClassName} // Apply row color based on 'color' column
            onRow={(record) => ({
              style: {
                backgroundColor: record.color || 'transparent', // apply any color
              },
              onDoubleClick: (e) => {
                // Check if the column has 'showDetail' and open the modal
                const keys = Object.keys(record);

                keys.forEach((key) => {
                  if (key.includes('showDetail')) {
                    //   console.log(`Details for ${record[key]}`);

                    openDetailModal(`Details for ${record[key]}`);
                  } else if (key.includes('statement')) {
                    //   console.log(`Details for ${record[key]}`);

                    openStatementlModal(record[key]);
                  }
                });
              },
            })}
            scroll={{ x: false }}
            // scroll={{ x: false, y: 400 }} // Disable horizontal scrolling
            // virtual={true} // This enables virtual scrolling (only visible rows are rendered)
            locale={{
              emptyText:
                filteredData.length === 0
                  ? 'No Data Available'
                  : 'No matching data',
            }}
            pagination={{
              defaultPageSize: pageSize, // Set the default number of records per page to 100
              showSizeChanger: true, // Optionally, allow the user to change the page size
              pageSizeOptions: ['10', '20', '50', '100', '250', '500', '1000'], // Provide options for page size
            }}
            className="fixed-header-table"
            {...(link?.has_footer === '1'
              ? {
                  summary: () => {
                    const lastRow = filteredData[filteredData.length - 1]; // Get last row of data
                    return (
                      <DataTable.Summary.Row>
                        {link?.sms_sample && (
                          <DataTable.Summary.Cell key="extra-empty" />
                        )}
                        {columns.map((col) => (
                          <DataTable.Summary.Cell key={col.key}>
                            <strong>{lastRow?.[col.dataIndex] || ''}</strong>
                          </DataTable.Summary.Cell>
                        ))}
                      </DataTable.Summary.Row>
                    );
                  },
                }
              : {})}
          />
          {/* Example: Display checked rows */}
          {/* <pre>{JSON.stringify(selectedRowKeys, null, 2)}</pre> */}
        </div>
      )}
      {executionTime !== null && (
        <p>
          Request executed in: {executionTime.toFixed(2)} sec - Total rows:
          {data && (link?.has_footer == 1 ? data.length - 1 : data.length)} rows
        </p>
      )}

      {/* Modal for showing details */}
      <Modal
        title="Details"
        open={detailModalVisible} // Use 'open' instead of 'visible'
        onCancel={closeDetailModal}
        footer={[
          <Button key="close" onClick={closeDetailModal}>
            Close
          </Button>,
        ]}
      >
        <p>{modalContent}</p>
      </Modal>

      {/* Modal for showing statement */}
      <DataModal
        title={'Statement'}
        data={statement}
        editDelPermission={editDelPermission}
        isOpen={statementModalVisible}
        onRequestClose={closeStatementModal}
      />
      {/* GLOBAL Modal */}

      <div
        className="modal fade"
        id="galleryModal"
        tabIndex="-1"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-fullscreen">
          <div className="modal-content bg-dark">
            <div className="modal-body p-0">
              <div
                id="galleryCarousel"
                className="carousel slide"
                data-bs-ride="false"
              >
                <div
                  className="carousel-inner h-100"
                  id="carousel-inner-container"
                ></div>

                <button
                  className="carousel-control-prev"
                  type="button"
                  data-bs-target="#galleryCarousel"
                  data-bs-slide="prev"
                >
                  <span className="carousel-control-prev-icon"></span>
                </button>
                <button
                  className="carousel-control-next"
                  type="button"
                  data-bs-target="#galleryCarousel"
                  data-bs-slide="next"
                >
                  <span className="carousel-control-next-icon"></span>
                </button>
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn btn-light" data-bs-dismiss="modal">
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DTTable;
